import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { LoginModel } from '../../auth-models';
import { AuthService } from '../../auth.service';

@Component({
  selector: 'app-family-login',
  templateUrl: './family-login.component.html',
  styleUrls: ['./family-login.component.scss'],
  standalone: false,
})
export class FamilyLoginComponent implements OnInit {
  loginFailed = false;
  isBusy = false;
  isMfaTokenVisible = false;
  mfaToken: any = {};
  mfaErrorMessage = '';
  email = '';
  loginFailCount = 0;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private authService: AuthService,
    private router: Router
  ) {}

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset).pipe(
    map((result) => result.matches),
    shareReplay()
  );

  ngOnInit() {}

  onSubmit(creds: LoginModel) {
    this.loginFailed = false;
    this.isBusy = true;
    this.authService.login(creds).subscribe(
      () => {
        if (this.authService.isAuthenticated) {
          this.loginFailCount = 0;
          if (this.authService.isPortalUser) {
            if (this.authService.isMultifactorAuthenticationRequired) {
              this.email = creds.email;
              this.isMfaTokenVisible = true;
            } else {
              this.authService.navigateToPortal();
            }
          } else {
            this.authService.navigatePostAuth();
          }
        }
        this.isBusy = false;
      },
      (err: any) => {
        this.loginFailed = true;
        this.loginFailCount++;
        this.isBusy = false;
        console.log('Login error...');
        console.log(err);
      }
    );
  }

  onSubmitMfa(mfa) {
    this.mfaToken.pinCode = mfa.pin;
    this.mfaToken.email = this.email;
    this.loginFailed = false;
    this.isBusy = true;
    this.authService.mfa(this.mfaToken).subscribe(
      () => {
        if (this.authService.isAuthenticated) {
          this.loginFailCount = 0;
          if (this.authService.isPortalUser) {
            this.authService.navigateToPortal();
          } else {
            this.authService.navigatePostAuth();
          }
        }
        this.isBusy = false;
      },
      (err: any) => {
        this.loginFailed = true;
        this.loginFailCount++;
        this.isBusy = false;
        console.log('Login error...');
        console.log(err);
      }
    );
  }
}
